export const CACHE_KEY = "professional_cert_checkout_form_cache";

// Helper functions for session storage cache management
export const getCachedFormData = (): any => {
	const cached = sessionStorage.getItem(CACHE_KEY);
	return cached ? JSON.parse(cached) : null;
};

export const setCachedFormData = (data: any): void => {
	sessionStorage.setItem(CACHE_KEY, JSON.stringify(data));
};

export const clearCachedFormData = (): void => {
	sessionStorage.removeItem(CACHE_KEY);
};
